/**
 * Минимальная сумма заказа из разметки
 */
export const minSumOrder = (window.app && window.app.minSumOrder) || 10000
